import React from "react"
import PropTypes from "prop-types"
import { Label, Row } from "reactstrap"
import { AvField, AvRadioGroup, AvRadio } from "availity-reactstrap-validation"
import { parameterCode } from "constant/utility"

//i18n
import { withTranslation } from "react-i18next"
import { CustomSelect } from "components/Common"

const FilterForm = ({ model, t }) => {
  return (
    <>
      <Row>
        <div className="mb-3">
          <Label for="example">{t("Profile Search")}</Label>
          <AvField
            name="search"
            type="text"
            className="form-input"
            value={model.search || ""}
          />
        </div>
      </Row>
      <Row>
        <div className="mb-3">
          <Label for="example">{t("Profile Type")}</Label>
          <CustomSelect
            portal
            name="type"
            value={model.type || ""}
            code={parameterCode.PARTY_TYPE_CODE}
            onChange={(name, value, label, item) => {
              model.type = value[0];
          }}
          />
        </div>
      </Row>
      <Row>
        <div className="mb-3">
          <Label for="example">{t("common:Active")} ?</Label>
          <AvRadioGroup name="status" value={model.status || ""}>
            <AvRadio label={t("common:Yes")} value="true" />
            <AvRadio label={t("common:No")} value="false" />
          </AvRadioGroup>
        </div>
      </Row>
    </>
  )
}

FilterForm.propTypes = {
  model: PropTypes.object,
  t: PropTypes.any,
}

export default withTranslation(["profilePage", "common"])(FilterForm)
